import * as UserActions from './participant_actions';
import * as MetaActions from './meta_actions';

export const actions = { ...UserActions, ...MetaActions };



// WEBPACK FOOTER //
// ./src/actions/index.js